module.exports = __webpack_public_path__ + "static/media/quieromibarrio5.ee2fb481.webp";